<!-- Единая строка read-only данных внутри BaseInfoCard: label + значение или кастомный slot. -->
<template>
  <div
    class="base-info-field"
    :class="{ 'base-info-field--inline-on-wide': inlineOnWide }"
  >
    <span class="base-info-field__label">
      <BaseInfoTooltip
        v-if="displayInfo"
        :text="displayInfo"
        :filled="fieldFilled"
        variant="text"
      >
        {{ label }}
      </BaseInfoTooltip>
      <span v-else>{{ label }}</span>
    </span>
    <span class="base-info-field__value" v-if="!$slots.default">
      {{ displayValue }}
    </span>
    <div class="base-info-field__value" v-else>
      <slot />
    </div>
  </div>
</template>

<script>
import { fieldInfoByKey } from "@/config/fieldInfo";

export default {
  name: "BaseInfoField",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    emptyValue: {
      type: String,
      default: "—",
    },
    // Переключает read-only поле в горизонтальный вид на широких экранах:
    // label слева, значение справа, без локального CSS в доменных карточках.
    inlineOnWide: {
      type: Boolean,
      default: false,
    },
    info: {
      type: String,
      default: "",
    },
    // Ключ из src/config/fieldInfo.js для единого текста подсказки
    infoKey: {
      type: String,
      default: "",
    },
    filled: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    displayValue() {
      if (this.value === null || this.value === undefined || this.value === "") {
        return this.emptyValue;
      }

      return this.value;
    },
    fieldFilled() {
      if (this.filled !== null) return this.filled;

      return this.value !== null && this.value !== undefined && this.value !== "";
    },
    displayInfo() {
      return this.info || fieldInfoByKey(this.infoKey);
    },
  },
};
</script>

<style scoped>
.base-info-field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.base-info-field + .base-info-field {
  margin-top: 15px;
}

.base-info-field__label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #666;
  flex-shrink: 0;
}

.base-info-field__value {
  color: var(--color-dark);
  font-size: 14px;
  font-weight: 500;
  word-break: break-word;
}

@media (min-width: 1600px) {
  .base-info-field--inline-on-wide {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    column-gap: 15px;
  }
}
</style>
